class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0, 'remove');
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    
    this.enableDeliveryTreshold = document.querySelector('cart-drawer').getAttribute('data-show-delivery-threshold') === 'true' ? true : false;
    this.isCartPage = document.getElementById('cart__wrapper') ? true : false;
    
    if (this.enableDeliveryTreshold) {
      let progressBar = document.querySelector('.cart-drawer__progress_bar');
      progressBar.classList.remove('hidden');
      let shipping_threshold = progressBar.getAttribute('data-delivery-value');
      this.freeThreshold = Math.round(100 * parseFloat(shipping_threshold));
      this.progressBarShipping();
      if (this.isCartPage) document.querySelector('#cart__summmary .cart-drawer__progress_bar').classList.remove('hidden');
    }

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');
    if (this.isCartPage) this.removeOOSItemsOnLoad();
    if (!this.isCartPage) this.onCartDrawerOpen(); 
    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  onCartDrawerOpen() {
    // Select the element you want to observe
    const cartDrawer = document.querySelector('cart-drawer');
    // Create a MutationObserver instance
    const observer = new MutationObserver(mutationsList => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          if (cartDrawer.classList.contains('active')) {
            this.removeOOSItemsOnLoad();
          } else {
            document.querySelector('.cart-drawer__removed-item-message').classList.add('hidden');
          }
        }
      }
    });
    observer.observe(cartDrawer, { attributes: true });
  }

  removeOOSItemsOnLoad() {

    document.querySelectorAll('[data-item-qty="0"]').forEach((element) => {
      if (element.dataset.itemQty === '0' && element.dataset.itemTrackInventory != "") {
        const ind = element.querySelector('.quantity__input').dataset.index;
        const val = 0;
        this.updateQuantity(ind, val, '', true);
      }
    });
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart__summmary',
        section: document.getElementById('cart__summmary').dataset.id,
        selector: '.cart__total_and_discounts'
      }
    ];
  }

  updateQuantity(line, quantity, name, removeOnLoad = false) {
    this.enableLoading(line, name);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    // HOTFIX - added headers to potentially solve the back browser caching issue
    fetch(`${routes.cart_change_url}`,
      {
      headers: {"Cache-Control": "no-store, no-cache, must-revalidate, max-age=0"},
        ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');
        const cartSummary = document.getElementById('cart__summmary');
        const cartWrapper = document.getElementById('cart__wrapper');
        const productRecommendations = document.querySelector('.template-cart .product-recommendations-section ');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartSummary) cartSummary.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartWrapper) cartWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
        if (productRecommendations) productRecommendations.classList.toggle('hidden', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        if (removeOnLoad) {
          if (this.isCartPage) {
            document.querySelector('.cart__removed-item-message').classList.remove('hidden');
          } else {
            document.querySelector('.cart-drawer__removed-item-message').classList.remove('hidden');
          }
        }

        // commented out since we removed Quantity Selector - not removed just in case they want it back
        //this.disableQuantitySelector(line);
        if (this.enableDeliveryTreshold) this.progressBarShipping();
        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('.drawer__close'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
        this.disableLoading(line);
        window.CartRecommendedProducts.handleIntersection();
      }).then(() => {
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
      
        // commented out since we removed Quantity Selector - not removed just in case they want it back
        //this.disableQuantitySelector(line);
        if (errors) {
          errors.textContent = window.cartStrings.error;
        }
        this.disableLoading(line);
      });
  }

  disableQuantitySelector(line) {
    const _lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);

    let itemMaxInventory = parseInt(_lineItem.getAttribute('data-item-qty'));
    let quantityValue = parseInt(_lineItem.querySelector('.quantity__input').value);
    let addQuantitySelector = _lineItem.querySelector('quantity-input [name="plus"]');

    if (quantityValue >= itemMaxInventory) {
      addQuantitySelector.setAttribute('disabled', true);
      _lineItem.querySelector('.quantity__input').value = itemMaxInventory;
      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
      lineItemError
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          quantityElement.value
      );
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line, type) {

    const cartItemElements = this.querySelectorAll(`#CartItem-${line}`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line}`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((item) => {
      item.classList.add('cart__items--disabled')
    });


    const cartItemElementsLoading = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElementsLoading = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    let currentLoadingType = (type === 'plus' || type === 'minus') ? 'quantity' : type;

    [...cartItemElementsLoading, ...cartDrawerItemElementsLoading].forEach((overlay) => {
      if(overlay.dataset.loadingType == currentLoadingType){
        overlay.classList.remove('hidden');
      }
      
    });

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const cartItemElements = this.querySelectorAll(`#CartItem-${line}`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line}`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((item) => item.classList.remove('cart__items--disabled'));
  }

  progressBarShipping() { 

    let isCartDrawerEnabled = document.querySelector('.cart-drawer__progress_bar') ? true: false;
    if (!isCartDrawerEnabled) {
      return;
    }
    let progressBar = document.querySelector('.cart-drawer__progress_bar');
    let shipping_threshold = document.querySelector('[data-main-delivery-threshold-value]').getAttribute('data-main-delivery-threshold-value');
    let freeThreshold = Math.round(100 * parseFloat(shipping_threshold));
    this.freeThreshold = freeThreshold;
    fetch(window.Shopify.routes.root + 'cart.js')
      .then(response => response.json())
      .then(data => {

        let qualifiedSelector = this.isCartPage ? '#cart__summmary .cart-drawer__progress_bar .qualified' : '.cart-drawer__progress_bar .qualified';
        let not_qualifiedSelector = this.isCartPage ? '#cart__summmary .cart-drawer__progress_bar .not_qualified' : '.cart-drawer__progress_bar .not_qualified';
          
        const qualified = document.querySelector(qualifiedSelector);
        const not_qualified = document.querySelector(not_qualifiedSelector);
        this.setMoneyToSpendValue(data, this.freeThreshold);
        if (this.substractGiftCartValue(data) < this.freeThreshold) {
          qualified.classList.add('hidden');
          not_qualified.classList.remove('hidden');
        } else {
          not_qualified.classList.add('hidden');
          qualified.classList.remove('hidden');
        }
        this.setProgressBarPercentage(data, this.freeThreshold);
      })
      .then(function () {
      })
  }

  setProgressBarPercentage(cartObject, freeThreshold) {
    const bar = this.isCartPage ? document.querySelector('#cart__summmary .cart-drawer__progress_bar_value span') : document.querySelector('.cart-drawer__progress_bar_value span');
    let percent = (this.substractGiftCartValue(cartObject)/freeThreshold)*100;
    if(percent > 100) {
      percent = 100;
      bar.classList.add('qualified');
    } else {
      bar.classList.remove('qualified');
    }
    bar.style.width = percent+'%';
  }

  setMoneyToSpendValue(cartObject, freeThreshold) {
    // Select the correct element based on this.isCartPage
    const selector = this.isCartPage ? '#cart__summmary .cart-drawer__progress_bar .not_qualified .spent_x' : '.cart-drawer__progress_bar .not_qualified .spent_x';
    const not_qualified_spentX = document.querySelector(selector);

    // Check if the element exists before proceeding
    if (not_qualified_spentX) {
      // Extract the current spentXValue
      let spentXValue = not_qualified_spentX.getAttribute('data-spent-x-text');

      // Calculate the value to spend and format it as currency
      let valueToSpend = freeThreshold - this.substractGiftCartValue(cartObject);
      const formatedValueToSpend = (parseFloat(valueToSpend / 100)).toLocaleString(Shopify.country, {
        style: 'currency',
        currency: Shopify.currency.active
      });

      // Update the spentXValue
      spentXValue = spentXValue.replace(/x_value/g, formatedValueToSpend);

      // Update the innerHTML of the element
      not_qualified_spentX.innerHTML = spentXValue;

      // Debugging: Log the updated spentXValue
    } else {
      // Handle the case when the element is not found
      console.error('Element not found.');
    }
  }

  substractGiftCartValue(cartObject) {
    let gcProds = cartObject.items.filter((item => item.url.includes('gift-card?')));
    let gcCosts = 0;
    if(gcProds.length > 0) {
      gcProds.forEach((item) => {
        gcCosts += item.final_line_price;
      })
    }
    return cartObject.total_price - gcCosts;
  }

}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  });
};
